import { useMediaQuery } from 'react-responsive';
export const useTabletOrWider = (settings = {}, device, callback) => useMediaQuery(Object.assign(Object.assign({}, settings), { minWidth: 768 }), device, callback);
export const useDesktopOrWider = (settings = {}, device, callback) => useMediaQuery(Object.assign(Object.assign({}, settings), { minWidth: 1268 }), device, callback);
